import { CenterTeamMember } from '../../lib/types/models/center/center-team'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterTeam(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterTeam.url, { id }))
    .get<CenterTeamMember[]>()
}
